import styled from "styled-components";

export const LiveCasinoGridItemOpenAtBox = styled.div`
    width: 100%;
    font-size: 2.25em;
    font-weight: 700;
`;